import React, { Fragment } from 'react';
import ToolBarMenu from '../../components/ToolBarMenu/index';
import Header from '../../components/Header/index';
import PageHeader from '../../components/PageHeader/index';
import Footer from '../../components/Footer/index';
import PageWrapper from '../../components/PageWrapper/index';
import { useCustomerCommunication } from '../../queries/customerCommunication';
import './index.scss';
import { useParams } from 'react-router-dom';
import {getImagesWithAbsolutePath, myDomain} from '../../helpers/urlHelper';
import InfinitProgressBar from '../../components/InfiniteProgressBar';
import { Button } from 'react-bootstrap';
import { saveAs } from 'file-saver';

const CustomersService = () => {

    const buttonStyle = {
        width:"160px",
        height: '45px',
        padding: '1%',
        border: '1px solid red',
        backgroundColor: 'red',
        borderRadius: '12px',
        color: '#fff',
        cursor:"pointer",
        textAlign: 'center',
        paddingBottom: '5%',
        margin: '-5% 76% 0% 2%',
        paddingBottom: '0%',
    }

    const saveFile = (url) => {
            saveAs(
                process.env.REACT_APP_BASE_URL + url
            );
          }
    

    const{id} = useParams()
    
    const CustomerCommunicationInfo = useCustomerCommunication(id);
    if (CustomerCommunicationInfo.error) return <div>error!</div>
    if (CustomerCommunicationInfo.loading) return <InfinitProgressBar />
    console.log(CustomerCommunicationInfo.data);
    return (  
        <Fragment>
            {/* <ToolBarMenu/> */}
            <Header/>
            <PageHeader
                bgImg={CustomerCommunicationInfo.data.customercommunication[0].customerCommunicationHeader.urls[0]}
                title={CustomerCommunicationInfo.data.customercommunication[0].displayText}
                content=''
            />
            <div style={{padding:"3rem 10%", lineHeight:"40px"}} className={`col-12  ${id === "foreignmarkets"? 'table-style' : null}`} dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(CustomerCommunicationInfo.data.customercommunication[0].htmlBody.html, myDomain)}}/>
            <div style={buttonStyle} onClick={()=>saveFile(CustomerCommunicationInfo.data.customercommunication[0].bag.contentItems[0].announcementFile.urls[0])}>
                {CustomerCommunicationInfo.data.customercommunication[0].bag.contentItems[0].displayText}
            </div>
            <br/>
            <br/>
            <br/>
            <Footer/>
        </Fragment>
    );
}
 
export default CustomersService;